import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext } from "react";
import {
  CopyPortalLicenseClientEventsData,
  ItemViewModel,
  ProgramReportInfo,
} from "../../../../../../../generated/data-contracts";
import { LicenseesUtils } from "../../../../../../../utils";
import { AvisForm } from "../../../../../../shared/components";
import {
  AvisDescriptiveText,
  AvisSection,
} from "../../../../../../shared/components/form";
import { AvisDropdown } from "../../../../../../shared/components/inputs";
import { AvisContext } from "../../../../../../shared/context/AvisContext";

interface ICopyProgramReportFormProps {
  bag: FormikProps<CopyPortalLicenseClientEventsData>;
  sourceProgramReport: ProgramReportInfo;
  availableDestinations: ItemViewModel[];
  loading: boolean;
}
export function CopyProgramReportForm(
  props: Readonly<ICopyProgramReportFormProps>,
) {
  const { bag, sourceProgramReport, availableDestinations } = props;
  const { res } = useContext(AvisContext);

  const selectedValueFiltred = availableDestinations.filter(
    (item) => item.id === bag.values.destinationPortalLicenseClientEventId,
  );
  const selectedValueName =
    selectedValueFiltred.length > 0 ? selectedValueFiltred[0].name : undefined;
  return (
    <AvisForm>
      <AvisDescriptiveText
        className="p-0"
        textKey="portal_LIC_ProgramReportCopy"
      />
      <AvisSection
        title={res("licensees_CopyProgramReport_ProgressDialog_label_CopyFrom")}
      >
        <div>{LicenseesUtils.formatProgramReportInfo(sourceProgramReport)}</div>
      </AvisSection>
      <AvisSection
        title={res("licensees_CopyProgramReport_ProgressDialog_label_CopyTo")}
      >
        <div title={selectedValueName}>
          <AvisDropdown<ItemViewModel, CopyPortalLicenseClientEventsData>
            bag={bag}
            bagField="destinationPortalLicenseClientEventId"
            options={availableDestinations}
            optionValue="id"
            optionLabel="name"
            filterPlaceholder={res(
              "licensees_CopyProgramReport_ProgressDialog_label_SearchPP",
            )}
            filter
            emptyFilterMessage={res("message_NoRelevantItems")}
            hideClear
            required
            reserveErrorMessageSpace={true}
            appendTo={document.body} // Append to the body - to enable drawing outside modal window
          />
        </div>
        <DotsCheckbox<CopyPortalLicenseClientEventsData>
          checkboxLabel={res(
            "licensees_CopyProgramReport_ProgressDialog_label_Overwrite",
          )}
          bag={bag}
          bagField="overwriteExistingProgramReport"
        />
      </AvisSection>
    </AvisForm>
  );
}
